// SymbolHeader.js
import React, { useEffect, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import { useTheme } from '../../../../../../utils/coins/useTheme';

const SymbolInfoNoSSR = dynamic(
    () => import('react-ts-tradingview-widgets').then((w) => w.SymbolInfo),
    {
        ssr: false,
    },
);

interface TradingViewProps {
    slug: string;
}

const SymbolHeader: React.FC<TradingViewProps> = ({ slug }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const chartRef = useRef<HTMLDivElement | null>(null); // type chartRef as HTMLDivElement
    const [theme] = useTheme('Light'); // Use the custom hook for theme

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const [entry] = entries;
                if (entry.isIntersecting && !isLoaded) {
                    setIsLoaded(true);
                }
            },
            { threshold: 0.1 }, // Trigger when 10% of the element is visible
        );

        const currentChartRef = chartRef.current; // Store the current reference in a variable

        if (currentChartRef) {
            observer.observe(currentChartRef);
        }

        return () => {
            if (currentChartRef) {
                observer.unobserve(currentChartRef); // Cleanup using the stable reference variable
            }
        };
    }, [isLoaded]);
    return (
        <div ref={chartRef} className={'w-full'}>
            {isLoaded && (
                <SymbolInfoNoSSR
                    colorTheme={theme.toLowerCase() as 'light' | 'dark'}
                    symbol={slug}
                    autosize
                ></SymbolInfoNoSSR>
            )}
        </div>
    );
};

export default SymbolHeader;
